export const TIMEOUT_MARGIN = 5;
export class SessionTimer {
    constructor() {
        this.timerId = -1;
    }
    startTimer(cb, duration) {
        if (this.timerId === -1) {
            this.timerId = window.setTimeout(cb, duration);
        }
    }
    clearTimer() {
        if (this.timerId) {
            window.clearTimeout(this.timerId);
            this.timerId = -1;
        }
    }
    handleExpiryTimeout(cb, exp) {
        if (exp <= 0) {
            if (typeof cb === 'function') {
                cb();
            }
        }
        const timeNow = Date.now() / 1000;
        const diff = Math.floor(exp - timeNow - TIMEOUT_MARGIN) * 1000;
        this.clearTimer();
        this.startTimer(cb, diff);
    }
}
;
//# sourceMappingURL=sessionTimer.js.map